<template>
  <div>
    <d-table
      v-if="tableReady"
      tableName="loadboard"
      :data_object="data_object"
      :getFreshData="true"
      :linkClick="linkClick"
      :link="link"
      :mobileBreakpoint="'0'"
      :onDataReceived="onDataReceived"
      :getRowClass="getRowClass"
      :coloredFields="coloredFields"
      :getItemColor="getItemColor"
      :itemsPerPage="12"
      :filterCondition="filterCondition"
      :searchableColumns="searchableColumns"
      :hasSearch="true"
      :hasAdvancedSearch="true"
      ref="dTable"
      :key="tableKey"
      :serverPagination="false"
      :remoteSearch="false"
      :showGroupBy="true"
      sortBy="shipment_id"
      :sortDesc="true"
      v-bind="vBind"
      :noDelete="noDelete"
      :toolBarControls="toolBarControls"
      :refreshParent="refreshParent"
      :toolbarRight="true"
      :columnTool="true"
    />
    <v-alert
      class="ma-4"
      dismissible
      timeout="3000"
      v-if="successMessage != '' && !noAlert"
      type="success"
    >
      {{ successMessage }}
    </v-alert>
    <v-alert
      class="ma-4"
      timeout="3000"
      dismissible
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>
<script>
import DTable from "../components/Table";
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  components: { DTable },
  props: {
    searchInput: String,
  },
  data() {
    return {
      tblClass: "",
      successMessage: "",
      errorMessage: "",
      tableKey: 0,
      tableReady: false,
      getFreshData: true,
      excludedFields: [
        "_id",
        "zone",
        "broker",
        "broker_email",
        "datereceived",
        "agent",
        "boardurl",
        "brokerid",
        "agentid",
        "available",
        "body",
        "id",
        "portalid",
        "end__date",
        "datereceived",
        "mail_sent",
        "shipments",
        "brokers",
        "matchingBrokers",
      ],

      // link: {
      //   field: "shipment_id",
      //   name: "shipment",
      // },

      data_object: {
        object_name: "v_loadboard",
        schema_name: "loadboard",
        additional_data: [
          // {
          //   obj_name: "broker",
          // },
          {
            obj_name: "company",
          },
        ],

        mobileBreakpoint: 0,
        all_records: true,
        // additional_data: [
        //   { obj_name: "service_type" },
        //   { obj_name: "lead_status" },

        //   { obj_name: "company" },
        // ],

        item_key: "id",
        table_title: "Loadboard",
        hasSearch: true,
        broker: [],
      },
      coloredFields: [],
      serviceTypes: [],
      leadStatus: [],
      company: [],
      stages: [],
      filterTabs: [],
      originalRecords: [],
      searchableColumns: [],
      vBind: {},
      selectRecords: false,
      plansSelected: [],
      toolBarControls: [],
      showAgentList: 0,
      agent: "",
      currentUser: "",
      noDelete: true,
      loadboardData: [],
      emoverPortalId: 257,
    };
  },
  mounted() {
    var that = this;
    this.data_object.qry = {};
    this.$root.$on("customBtnClick", (f) => {
      if (f.btn == "assignAgents") {
        that.showAgents();
      }
    });
    this.currentUser = this.$root.store.userData.email;
    var permittedActions = this.$root.store.permittedActions;
    permittedActions.forEach((a) => {
      if (a.bulk_delete) {
        this.noDelete = false;
      }
      if (a.bulk_delete) {
        this.noDelete = false;
      }
      if (a.filter_jobs) {
        this.data_object.qry.sales_person_email = this.currentUser;
      }
      if (a.hide_booked_jobs) {
        this.data_object.qry.booked = 0;
      }
    });

    this.tableReady = true;
    this.$root.$on("tableSelectionChanged", (t) => {
      that.plansSelected = t.selected;
      that.showAgentList = t.selected.length;
      that.toolBarControls[1].hidden = !that.showAgentList;
    });
    // this.toolBarControls = [];
    this.toolBarControls = [
      {
        comp: "v-btn",
        id: "assignAgents",
        "v-bind": {
          color: "info",
          text: true,

          icon: "mdi-account-check",
          "input-value": "Assign Carriers",
        },
      },
      {
        comp: "v-combo",
        id: "carriers",
        hidden: !this.showAgentList,
        model: this.agent,
        "v-bind": {
          objName: "agent",
          itemText: "full_name",
          itemValue: "_id",
          returnObject: true,
          onValueChange: this.assignAgents,
          clearable: true,
        },
      },
    ];
    this.getSqlData();
  },

  methods: {
    refreshParent() {
      // this.tableReady = false;
      this.getSqlData();
      // this.tableReady = true;
    },
    getSqlData() {
      var data = {
        sql: "Select * from vLoadboard where PortalID=" + this.emoverPortalId,
        sql_table: "tblLoadboard",
        mongo_table: "sql_loadboard",

        conn: "production",
        update_cond: {
          destination_table: "loadboard",
          compare_field: "job__no___",
        },
      };
      axios
        .post(this.serverURL + "/import_table_from_sql", data, {
          withCredentials: true,
        })
        .then((response) => {
          var data = response.data;
          this.tableReady = true;
        });
    },
    linkClick(item) {
      this.$root.addResentTab(item);
    },
    showAgents() {
      // console.log("assign Sales");
      this.$refs.dTable.selected = [];
      this.$refs.dTable.select = !this.$refs.dTable.select;
      this.selectRecords = this.$refs.dTable.select;

      var btnLabel = this.selectRecords
        ? "Please select records to assign"
        : "Assign Carrier";
      this.toolBarControls[0]["v-bind"]["input-value"] = btnLabel;
      this.toolBarControls[1].hidden = !this.showAgentList;
      //plansSelected
    },
    assignAgents(cmb) {
      console.log(cmb.value);
      this.agent = cmb.value;
      if (this.showAgentList && cmb.value) {
        // if (cmb.value) {
        var confirmLabel = cmb.value
          ? "Confirm assigning " +
            this.plansSelected.length +
            " record(s) to " +
            cmb.value.full_name +
            "?"
          : "Confirm removing agent from " +
            this.plansSelected.length +
            " record(s)?";
        this.$root.$confirm
          .open("Delete", confirmLabel, {
            color: "red",
          })
          .then((confirm) => {
            if (confirm) {
              var ids = [];
              this.plansSelected.forEach((r) => {
                ids.push(r._id);
              });
              this.updateAgents(cmb.value, ids);
            }
          });
        // }
      }
    },
    sendRequestToBroker() {
      var that = this;
      this.plansSelected.forEach((p) => {
        var subject = "Please send full job information";
        var leadInfo = [];
        Object.keys(p).forEach((k) => {
          if (!that.excludedFields.includes(k)) {
            leadInfo.push(fun.capitalize(k) + ": " + p[k] + "<br>");
          }
        });
        var company = "";
        if (this.company.length == 1) {
          company = this.company[0];
        } else {
          //is_default
          company = this.company.filter((c) => {
            return c.is_default;
          })[0];
        }
        var brokerEmail = p.broker_email;

        var carrier = that.agent.full_name;

        var msg = `Please send full job information to ${
          company.company_name
        } email: ${
          company.email
        } on behalf of ${carrier}<br><br>${leadInfo.join("")} `;

        var mailData = {
          message: msg,
          subject: subject,
          comp_id: company._id,
          email_to: [brokerEmail],
        };
        this.$root.sendMail(mailData);
      });
    },
    updateAgents(v, ids) {
      var that = this;
      var metadata = {
        object_name: "loadboard",
        ids: ids,
      };
      var data = {
        metadata: metadata,
        model: {
          agent: v || "",
          mail_sent: new Date(),
        },
      };

      axios
        .post(this.serverURL + "/update_many", data, {
          withCredentials: true,
        })
        .then((r) => {
          // console.log(r);
          // this.$refs.dTable.select = false;

          this.sendRequestToBroker();
          this.$refs.dTable.selected = [];
          this.showAgents();

          this.successMessage = r.data;
        });
    },
    getItemColor(value, field) {
      var color = "black";
      switch (field) {
        case "service_type":
          this.serviceTypes.forEach((s) => {
            if (s.service_type == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "";
              }
            }
          });
          // if (!isItem) {
          //   return "color-" + color;
          // } else {
          return color;
        // }

        case "lead_status":
          this.leadStatus.forEach((s) => {
            if (s.status == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "black";
              }
            }
          });
          return color;
        case "company_name":
          this.company.forEach((s) => {
            if (s.company_name == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "black";
              }
            }
          });
          return color;
        default:
          break;
      }
      // if (field == "service_type") {
      //   return this.getServiceColor(value, true);
      // }
      // if (field == "booked") {
      //   return value == "Booked" ? "green" : "black";
      // }
      // if (field == "lead_status") {
      //   return value == "Booked" ? "green" : "black";
      // }
    },
    getRowClass(item) {
      return "";
    },

    getServiceColor(serviceType, isItem) {
      var color = "";
      this.serviceTypes.forEach((s) => {
        if (s.service_type == serviceType) {
          if (s.color && s.color.replace) {
            if (!isItem) {
              color = s.color.replace("#", "");
            } else {
              color = s.color;
            }
          } else {
            color = "";
          }
        }
      });
      if (!isItem) {
        return "color-" + color;
      } else {
        return color;
      }
    },
    onDataReceived(data) {
      this.company = data.additional_model.company;
      return data;
    },
    // onDataReceived(data) {
    //   this.vBind = data.schema["v-bind"];
    //   this.serviceTypes = data.additional_model.service_type;
    //   this.leadStatus = data.additional_model.lead_status;
    //   this.company = data.additional_model.company;
    //   if (this.company.length == 1) {
    //     data.schema.properties["company_name"].hideInTable = true;
    //   }
    //   this.stages = data.additional_model.stage;
    //   // this.filterTabs = [];
    //   // if (!this.filterTabs.length) {
    //   //   this.leadStatus.forEach((t) => {
    //   //     var oStatus = {
    //   //       caption: t.status,
    //   //       name: "lead_status",
    //   //       value: t.status,
    //   //       color: t.color,
    //   //     };
    //   //     this.filterTabs.push(oStatus);
    //   //   });
    //   // }

    //   var classes = "";
    //   this.serviceTypes.forEach((s) => {
    //     try {
    //       if (s.color && s.color.replace) {
    //         var className = "color-" + s.color.replace("#", "");
    //         var classCss = "border: 5px solid " + s.color + ";";

    //         var cl = "\n." + className + " { " + classCss + "}";
    //         if (classes.indexOf(cl) == -1) {
    //           classes += cl;
    //         }
    //       }
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   });

    //   this.$root.dynamicClasses(classes);
    //   // this.tableKey = !this.tableKey;
    //   data.table = data.model;
    //   return data;
    // },
  },
  watch: {},
};
</script>
<style scoped>
.v-tab {
  background-color: white;
  margin: 1px !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border: solid 1px;
}
</style>
